import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type BtnVariant = 'primary' | 'default' | 'ghost' | 'danger' | 'subtle';

export interface BtnProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  variant?: BtnVariant;
  size?: 'sm' | 'md' | 'lg';
  children?: ReactNode;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  full?: boolean;
  danger?: boolean;
  loading?: boolean;
}

const SIZES = {
  sm: { h: 28, p: '0 10px', fs: 12.5, gap: 6 },
  md: { h: 34, p: '0 14px', fs: 13, gap: 8 },
  lg: { h: 44, p: '0 18px', fs: 14, gap: 10 },
} as const;

export function Btn({
  variant = 'default',
  size = 'md',
  children,
  leftIcon,
  rightIcon,
  full,
  danger,
  loading = false,
  type = 'button',
  disabled,
  style,
  ...rest
}: BtnProps) {
  const sizes = SIZES[size];
  return (
    <button
      {...rest}
      type={type}
      disabled={disabled || loading}
      data-variant={danger ? 'danger' : variant}
      className="ri-btn"
      style={{
        height: sizes.h,
        padding: sizes.p,
        fontSize: sizes.fs,
        gap: sizes.gap,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: full ? '100%' : undefined,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {loading ? (
        <span
          aria-hidden
          style={{
            width: sizes.fs,
            height: sizes.fs,
            borderRadius: 999,
            border: '2px solid currentColor',
            borderTopColor: 'transparent',
            animation: 'ri-spin 0.7s linear infinite',
          }}
        />
      ) : (
        leftIcon
      )}
      {children}
      {rightIcon}
    </button>
  );
}
